import React from 'react';
import DOMPurify from 'dompurify';
import './cms-banner.css';

DOMPurify.addHook('uponSanitizeElement', node => {
  if (node.tagName !== 'IFRAME') return;
  const src = node.getAttribute('src') || '';
  if (!/^https:\/\/www\.(youtube\.com|youtube-nocookie\.com)\/embed\//.test(src)) node.parentNode?.removeChild(node);
});

export function bannerStyles(json) {
  let values;
  try { values = typeof json === 'string' ? JSON.parse(json) : json; } catch { return {}; }
  if (!values || typeof values !== 'object') return {};
  return {
    color: values.colorTexto || undefined,
    background: values.colorFondo || undefined,
    fontSize: values.tamanoBase || undefined,
    textAlign: values.alineacion || undefined,
    width: values.ancho === 'full' ? '100%' : values.ancho === 'contenido' ? 'fit-content' : values.ancho || undefined,
    borderRadius: values.radio || undefined,
  };
}

export default function CmsBanner({ contenido, mediaUrl = contenido.mediaUrl, label = 'Novedades de Neurosueño' }) {
  const hasMedia = Boolean(mediaUrl) && ['imagen', 'video', 'banner'].includes(contenido.tipo);
  const isVideo = contenido.tipo === 'video' || /\.(mp4|webm)(?:[?#]|$)/i.test(mediaUrl || '');
  const hasText = Boolean(contenido.titulo || contenido.cuerpoHtml);
  return (
    <article className={`neuro-promo ${hasMedia ? 'neuro-promo--media' : ''} ${!hasText ? 'neuro-promo--image-only' : ''}`} style={bannerStyles(contenido.estilosJson)} aria-label={contenido.titulo || label}>
      {hasText && <div className="neuro-promo-copy">
        <span className="neuro-promo-eyebrow"><span aria-hidden="true">✦</span> {label}</span>
        {contenido.titulo && <h2 className="neuro-promo-title">{contenido.titulo}</h2>}
        {contenido.cuerpoHtml && <div className="neuro-promo-html" dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(contenido.cuerpoHtml, { ADD_TAGS: ['iframe'], ADD_ATTR: ['allow', 'allowfullscreen', 'frameborder', 'target'] }) }} />}
      </div>}
      {hasMedia && <div className="neuro-promo-visual">{isVideo
        ? <video src={mediaUrl} controls preload="metadata" aria-label={contenido.titulo || 'Video de Neurosueño'} />
        : <img src={mediaUrl} alt={hasText ? '' : contenido.titulo || label} loading="lazy" />}</div>}
      {!hasMedia && <div className="neuro-promo-art" aria-hidden="true"><span>✦</span></div>}
    </article>
  );
}
